import { render, staticRenderFns } from "./UsersPrivilegePlacesWorkPlansDays.vue?vue&type=template&id=b0a943fa&scoped=true&"
import script from "./UsersPrivilegePlacesWorkPlansDays.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegePlacesWorkPlansDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a943fa",
  null
  
)

export default component.exports